import axios from 'axios';
import { ISearchRequest, SearchData } from '../../GeneralComponents/SearchResults/types/SearchData';

const API_URL = '/api/SearchResultsApi';

export const SearchApi = async (searchRequest: ISearchRequest): Promise<SearchData> => {
    try {
        const response = await axios.post<IAPIResponse>(API_URL, searchRequest, {
            headers: { 'Content-Type': 'application/json' },
        });
        return response.data.result as SearchData;
    } catch (error) {
        console.error('Error in SearchApi:', error);
        throw error;
    }
};

interface IAPIResponse {
    result: any;
    IsSuccess: boolean;
    Message: string;
}
